import { TableConfig } from '@shared/models/table-config.model';
import { ProductName } from '@core/constants';

export default {
  [ProductName.PAC_MA]: [
    {
      name: 'User',
      dataKey: 'user',
      frozen: true,
      headerStyles: {
        width: '15%',
        minWidth: '220px',
      },
      styles: {
        width: '15%',
        minWidth: '220px',
      },
      isSortable: true,
      sortBy: 'user/name',
      filterOptions: {
        template: 'user',
        propName: 'userId',
        filterEnabled: true,
      },
    },
    {
      name: 'Second Level',
      dataKey: 'secondLevelReview',
      headerStyles: {
        width: '9.5%',
        minWidth: '135px',
      },
      styles: {
        width: '9.5%',
        minWidth: '135px',
      },
      isSortable: true,
      sortBy: 'secondLevelReview',
      filterOptions: {
        template: 'multiselect',
        propName: 'secondLevelReview',
        filterEnabled: true,
      },
    },
    {
      name: 'Request Type',
      dataKey: 'requestTypes',
      headerStyles: {
        width: '9.5%',
        minWidth: '135px',
      },
      styles: {
        width: '9.5%',
        minWidth: '135px',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'requestType',
        filterEnabled: true,
      },
    },
    {
      name: 'NPI',
      dataKey: 'npIs',
      headerStyles: {
        width: '7%',
        minWidth: '100px',
      },
      styles: {
        width: '7%',
        minWidth: '100px',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'npi',
        filterEnabled: true,
        virtualScroll: true,
      },
    },
    {
      name: 'Specialty',
      dataKey: 'specialty',
      headerStyles: {
        width: '7%',
        minWidth: '105px',
      },
      styles: {
        width: '7%',
        minWidth: '105px',
      },
      isSortable: true,
      sortBy: 'specialty',
      filterOptions: {
        template: 'multiselect',
        propName: 'specialty',
        filterEnabled: true,
      },
    },
    {
      name: 'State',
      dataKey: 'postalStates',
      headerStyles: {
        width: '6.5%',
        minWidth: '90px',
      },
      styles: {
        width: '6.5%',
        minWidth: '0',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'postalState',
        filterEnabled: true,
      },
    },
    {
      name: 'Authorization Type',
      dataKey: 'authorizationTypes',
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'authorizationType',
        filterEnabled: true,
      },
    },
    {
      name: 'Client',
      dataKey: 'tenants',
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'tenant',
        filterEnabled: true,
      },
    },
    {
      name: 'Daily Line Limit',
      dataKey: 'dailyLimit',
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
      headerInfo: `Limit applies to users with daily line review restrictions (such as Birmingham physicians).
      For regular reviewers, leave blank.`,
    },
    {
      name: 'Daily Line Count',
      dataKey: 'dailyCount',
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
      headerInfo: `Limit applies to users with daily line review restrictions (such as Birmingham physicians). 
      For regular reviewers, leave blank.`,
    },
    {
      name: 'Max Lines in Queue',
      dataKey: 'totalLimit',
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
    },
    {
      name: 'Total Lines in Queue',
      dataKey: 'totalCount',
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
    },
    {
      name: 'On/Off',
      dataKey: 'isActive',
      headerStyles: {
        width: '6.5%',
        minWidth: '120px',
      },
      styles: {
        width: '6.5%',
        minWidth: '120px',
      },
      isSortable: true,
      sortBy: 'isActive',
      filterOptions: {
        template: 'select',
        propName: 'isActive',
        filterEnabled: false,
      },
    },
    {
      name: '',
      dataKey: 'delete',
      headerStyles: {
        width: '3%',
        minWidth: '48px',
      },
      styles: {
        width: '3%',
        minWidth: '48px',
      },
    },
  ] satisfies TableConfig,
  [ProductName.PAC_COM]: [
    {
      name: 'User',
      dataKey: 'user',
      frozen: true,
      headerStyles: {
        width: '15%',
        minWidth: '220px',
      },
      styles: {
        width: '15%',
        minWidth: '220px',
      },
      isSortable: true,
      sortBy: 'user/name',
      filterOptions: {
        template: 'user',
        propName: 'userId',
        filterEnabled: true,
      },
    },
    {
      name: 'Second Level',
      dataKey: 'secondLevelReview',
      headerStyles: {
        width: '9.5%',
        minWidth: '135px',
      },
      styles: {
        width: '9.5%',
        minWidth: '135px',
      },
      isSortable: true,
      sortBy: 'secondLevelReview',
      filterOptions: {
        template: 'multiselect',
        propName: 'secondLevelReview',
        filterEnabled: true,
      },
    },
    {
      name: 'Request Type',
      dataKey: 'requestTypes',
      headerStyles: {
        width: '9.5%',
        minWidth: '135px',
      },
      styles: {
        width: '9.5%',
        minWidth: '135px',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'requestType',
        filterEnabled: true,
      },
    },
    {
      name: 'NPI',
      dataKey: 'npIs',
      headerStyles: {
        width: '7%',
        minWidth: '100px',
      },
      styles: {
        width: '7%',
        minWidth: '100px',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'npi',
        filterEnabled: true,
        virtualScroll: true,
      },
    },
    {
      name: 'Specialty',
      dataKey: 'specialty',
      headerStyles: {
        width: '7%',
        minWidth: '105px',
      },
      styles: {
        width: '7%',
        minWidth: '105px',
      },
      isSortable: true,
      sortBy: 'specialty',
      filterOptions: {
        template: 'multiselect',
        propName: 'specialty',
        filterEnabled: true,
      },
    },
    {
      name: 'Health Plan State',
      dataKey: 'postalStates',
      headerStyles: {
        width: '6.5%',
        minWidth: '90px',
      },
      styles: {
        width: '6.5%',
        minWidth: '0',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'postalState',
        filterEnabled: true,
      },
    },
    {
      name: 'Authorization Type',
      dataKey: 'authorizationTypes',
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'authorizationType',
        filterEnabled: true,
      },
    },
    {
      name: 'Client',
      dataKey: 'tenants',
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      isSortable: false,
      filterOptions: {
        template: 'multiselect',
        propName: 'tenant',
        filterEnabled: true,
      },
    },
    {
      name: 'Daily Line Limit',
      dataKey: 'dailyLimit',
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
      headerInfo: `Limit applies to users with daily line review restrictions (such as Birmingham physicians).
      For regular reviewers, leave blank.`,
    },
    {
      name: 'Daily Line Count',
      dataKey: 'dailyCount',
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
      headerInfo: `Limit applies to users with daily line review restrictions (such as Birmingham physicians). 
      For regular reviewers, leave blank.`,
    },
    {
      name: 'Max Lines in Queue',
      dataKey: 'totalLimit',
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
    },
    {
      name: 'Total Lines in Queue',
      dataKey: 'totalCount',
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
    },
    {
      name: 'On/Off',
      dataKey: 'isActive',
      headerStyles: {
        width: '6.5%',
        minWidth: '120px',
      },
      styles: {
        width: '6.5%',
        minWidth: '120px',
      },
      isSortable: true,
      sortBy: 'isActive',
      filterOptions: {
        template: 'select',
        propName: 'isActive',
        filterEnabled: false,
      },
    },
    {
      name: '',
      dataKey: 'delete',
      headerStyles: {
        width: '3%',
        minWidth: '48px',
      },
      styles: {
        width: '3%',
        minWidth: '48px',
      },
    },
  ] satisfies TableConfig,
};
